import { format } from 'date-fns';
import React from 'react';
import { Skeleton } from 'ui';
import { RailsItem } from '~/typings/services/rails/item';

function formatDate(input: string) {
  return format(new Date(input), 'MM/dd');
}

interface Props {
  item: RailsItem;
}

export function EstimatedDeliveryRowFallback() {
  return (
    <div>
      Estimated Delivery <Skeleton className="inline-block h-4 w-36" />
    </div>
  );
}

const EstimatedDeliveryRow: React.FC<Props> = ({ item }) => {
  if (!item.estimated_delivery) {
    return null;
  }

  const { max_delivery_date: maxDate, min_delivery_date: minDate } =
    item.estimated_delivery;

  let date: string;

  if (maxDate && minDate) {
    date = `${formatDate(minDate)} - ${formatDate(maxDate)}`;
  } else if (minDate) {
    date = formatDate(minDate);
  } else if (maxDate) {
    date = formatDate(maxDate);
  } else {
    return null;
  }

  return (
    <div>
      Estimated Delivery: <b>{date}</b>
    </div>
  );
};

export default EstimatedDeliveryRow;
